import { ContainerHome } from "./styles";
import bg from '../../assets/bg1.jpg'
export function Home() {
    return (
        <ContainerHome>
            <img className="bg" src={bg} alt="dark color background with a circle on the right side" />
            <h1 className="title">Fractalia</h1>
            <p className="rectangle">Where worlds collide</p>
            <div className="subtitle">
                <p>
                    A portal has opened to a new dimension– you’re now digital and immortal.
                    This is Fractalia, a new space in the metaverse and home to Anima Plasma,
                    a unique digital clothing collection for the fractal travelers of Decentraland.
                </p>
                <p> DECENTRALAND (69, -34)</p>
            </div>
        </ContainerHome>
    )
}